import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import DeveloperMode from "@/pages/admin/DeveloperMode";

/**
 * DeveloperModeGuard - Single component that handles all auth and access checks
 * while ensuring DeveloperMode (and its hooks) are called consistently.
 */
export function DeveloperModeGuard() {
  const { user, loading } = useAuth();

  // Check if user is dev (only when user exists)
  const isDevUser = user && (user.email === 'dev@developer.local' || user.username === 'dev');

  return (
    <>
      {/* Always render DeveloperMode to ensure hooks are called consistently */}
      <DeveloperMode />
      
      {/* Navigate component - React Router will handle redirect after render */}
      {!loading && !user && <Navigate to="/login" replace />}
      {!loading && user && !isDevUser && <Navigate to="/dashboard" replace />}
      
      {/* Show loading overlay if still loading */}
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
        </div>
      )}
      
      {/* Show redirect overlay if unauthorized (will be replaced by Navigate) */}
      {!loading && (!user || !isDevUser) && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="text-white">Redirecting...</div>
        </div>
      )}
    </>
  );
}
